import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const modeloSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    exist: Yup.boolean(),
    titulo: Yup.string().trim().required(v.requiredField('titulo')),
    descricao: Yup.string().trim().notRequired(),
    tipo: Yup.object().nullable().required(v.requiredField('tipoDocumento', 'select')),
    ativo: Yup.object()
      .nullable()
      .when('exist', {
        is: true,
        then: (schema) => schema.required(v.requiredField('status', 'select')),
        otherwise: (schema) => schema.notRequired(),
      }),
    pdf: Yup.mixed().when('exist', {
      is: false,
      then: (schema) =>
        schema
          .required(v.requiredField('arquivo'))
          .test('fileType', 'Somente pdf é permitido', (file) => {
            if (!file) return false
            return file.type === 'application/pdf'
          }),
      otherwise: (schema) =>
        schema.notRequired().test('fileType', 'Somente pdf é permitido', (file) => {
          if (!file) return true // importante!
          return file.type === 'application/pdf'
        }),
    }),
  })
}
